// extracted by mini-css-extract-plugin
export default {"profile":"Profile_profile__O+yoY","medium":"Profile_medium__C3--n","small":"Profile_small__0CEQe"};